module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Tanach Study","short_name":"TS","description":"Tanach Study is a modern, web based platform for the study of the 24 books ofTanach","start_url":"/","background_color":"#009fc1","theme_color":"#009fc1","display":"minimal-ui","icon":"static/favicons/original-favicon.png"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
